// Import model
import { CreateAddressRequest } from '../models/CreateAddressRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateAddressRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateAddressRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateAddressRequest instance
   */
  static deserialize(json: string): CreateAddressRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateAddressRequest instance
   */
  static fromObject(obj: any): CreateAddressRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateAddressRequest');
    }


    const instance: CreateAddressRequest = {
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      country: obj['country'] as string | undefined,
      location: obj['location'] as any | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      state: obj['state'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateAddressRequest instances
   */
  static deserializeArray(json: string): CreateAddressRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateAddressRequest instance to a JSON string
   */
  static serialize(instance: CreateAddressRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateAddressRequest instance to a plain object
   */
  static toObject(instance: CreateAddressRequest): any {
    return {
      'address': instance.address,
      'city': instance.city,
      'country': instance.country,
      'location': instance.location,
      'postalCode': instance.postalCode,
      'state': instance.state,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of CreateAddressRequest instances to a JSON string
   */
  static serializeArray(instances: CreateAddressRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
